import { getStaticFilePath } from './uri';

const getPaymentIconFilePath = paymentType => getStaticFilePath(`/icons/payment/${paymentType}.png`);

const icons = {
    amex: getPaymentIconFilePath('amex'),
    gift: getPaymentIconFilePath('gift'),
    klarna: getPaymentIconFilePath('klarna'),
    mc: getPaymentIconFilePath('master-card'),
    wywallet: getPaymentIconFilePath('wy-wallet'),
    strex: getPaymentIconFilePath('strex'),
    visa: getPaymentIconFilePath('visa'),
    itunes: getPaymentIconFilePath('itunes'),
    telenor: getPaymentIconFilePath('telenor'),
    sms: getPaymentIconFilePath('sms'),
    vipps: getPaymentIconFilePath('vipps'),
    telia: getPaymentIconFilePath('telia'),
    ntm: getPaymentIconFilePath('ntm'),
    unt: getPaymentIconFilePath('unt'),
    storytel: getPaymentIconFilePath('storytel'),
    alcom: getPaymentIconFilePath('alcom'),
    swish: getPaymentIconFilePath('swish'),
};

export const getPaymentIconSrc = paymentType => icons[paymentType];
